<template>
  <div class="adviser-video-grid">
    <div
      v-for="video in playableVideos"
      :key="video.title"
      class="adviser-video"
    >
      <h2 class="video-title">{{ video.title }}</h2>
      <p class="video-description">{{ video.description }}</p>
      <div class="video-frame">
        <iframe
          :src="video.source"
          :title="video.title"
          frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowfullscreen
        ></iframe>
      </div>
    </div>
  </div>
</template>

<script>
  // Spec 4.9 video tiles: title, description, 16:9 YouTube embed. Same
  // iframe usage as components/people/AdditionalInfoComponent.vue.
  export default {
    name: 'AdviserVideoGrid',
    props: {
      // [{ title, description, source }]
      videos: {
        type: Array,
        required: true,
      },
    },
    computed: {
      // A tile without an embed URL is not rendered rather than shown blank.
      playableVideos() {
        return this.videos.filter(video => !!video.source);
      },
    },
  };
</script>

<style scoped lang="scss">
  @import '../../../constants/styles/adviser-pages.scss';

  .adviser-video-grid {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    column-gap: 36px;
    row-gap: 60px;

    @media only screen and (max-width: $adviser-mobile-breakpoint) {
      grid-template-columns: minmax(0, 1fr);
    }
  }

  .adviser-video {
    .video-title {
      @include adviser-font;
      font-weight: 600;
      font-size: 18px;
      line-height: 30px;
      color: $adviser-text-black;
      margin: 0 0 16px 0;
    }
    .video-description {
      @include adviser-body;
      color: $adviser-text-black;
      margin: 0 0 30px 0;
    }
    .video-frame {
      position: relative;
      width: 100%;
      aspect-ratio: 16 / 9;
      iframe {
        position: absolute;
        inset: 0;
        width: 100%;
        height: 100%;
      }
    }
  }
</style>
